import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const LoadingContainer = styled(Box)(({ theme, fullPage }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3),
  ...(fullPage && {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    zIndex: theme.zIndex.modal,
  }),
}));

const StyledCircularProgress = styled(CircularProgress)(({ theme, size }) => ({
  color: theme.palette.primary.main,
}));

const LoadingText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  color: theme.palette.text.secondary,
  fontWeight: 500,
}));

/**
 * Loading indicator component
 * @param {Object} props Component props
 * @param {string} props.message Loading message to display
 * @param {boolean} props.fullPage Whether to display as a full-page overlay
 * @param {number} props.size Size of the loading spinner
 * @returns {JSX.Element} LoadingIndicator component
 */
const LoadingIndicator = ({ 
  message = 'Loading...', 
  fullPage = false, 
  size = 40 
}) => {
  return (
    <LoadingContainer fullPage={fullPage}>
      <StyledCircularProgress size={size} />
      {message && <LoadingText variant="body1">{message}</LoadingText>}
    </LoadingContainer>
  );
};

export default LoadingIndicator;
